// Public Home surfaces may run without the Vienna analytics provider.
// Keep the call sites safe and side-effect free when it is not configured.
export const usePostHog = () => null;
